import { PageBlock, ContentBlock } from 'braid-design-system';
import type { ReactNode } from 'react';

export const NarrowPageBlock = ({ children }: { children: ReactNode }) => (
  <PageBlock width="medium">
    <ContentBlock width="small">{children}</ContentBlock>
  </PageBlock>
);
